export default __webpack_public_path__ + "static/media/twitter.a8410c48.svg";